<template>
  <span v-if="!noDigits">{{ value | numberFormattedShort }}</span>
  <span v-else>{{ value | numberFormatted }}</span>
</template>

<script>
export default {
  name: "NumberValueCell",
  props: {
    value: {},
    noDigits: {
      type: Boolean,
      default: false,
    },
  }
}
</script>

<style scoped>

</style>
